<template>
  <div>
    <div style="padding-top:.1rem">
      <div class="search" @click="!$isIframe ? getSearch() : ''">
        <img src="@/assets/img/search.png" alt="" />
        <div>搜索</div>
      </div>
    </div>
    <transition
      name="fade"
      @before-leave="changeallshow(false)"
      @after-enter="changeallshow(true)"
    >
      <div
        v-if="searchShow"
        style="height:100vh;width:100vw;background:#fff;position:absolute;top:0;left:0;z-index:9999999;"
        @touchstart="pullDown"
      >
        <van-search
          v-model="value"
          show-action
          placeholder="请输入搜索关键词"
          @search="onSearch"
          @cancel="onCancel"
        />
      </div>
    </transition>
    <!-- <van-popup
      class="find"
      position="left"
      style="height:100%;width:100%"
      v-model="searchShow"
    >
      <van-search
        v-if="searchShow"
        v-model="value"
        show-action
        placeholder="请输入搜索关键词"
        @search="onSearch"
        @cancel="onCancel"
    /></van-popup> -->
  </div>
</template>
<script>
export default {
  data() {
    return { searchShow: false, value: '' }
  },
  created() {},
  computed: {},
  methods: {
    pullDown() {
      this.$el.querySelector('.van-field__control').blur()
    },
    changeallshow(isState) {
      var bodyDoc = document.body
      if (isState) {
        this.topSpace = window.scrollY
        bodyDoc.style.position = 'fixed'
        bodyDoc.style.top = -this.topSpace + 'px'
      } else {
        bodyDoc.style.position = ''
        console.log(bodyDoc.style.position, 111)
        bodyDoc.style.top = ''
        window.scrollTo(0, this.topSpace) // 回到原先位置
      }
    },
    getSearch() {
      this.searchShow = true
      this.$nextTick(() => {
        this.$el.querySelector('.van-field__control').focus()
      })
    },
    onSearch(a) {
      if (!a.trim()) {
        this.value = a.trim()
        return
      }
      this.changeallshow(false)
      this.$router.push('/searchReault?keyWord=' + a)
    },
    onCancel() {
      this.searchShow = false
      this.value = ''
    }
  }
}
</script>
<style lang="scss" scoped>
.search {
  margin-left: 0.15rem;
  width: 3.45rem;
  height: 0.29rem;
  background: #ededed;
  border-radius: 0.14rem;
  display: flex;
  align-items: center;
  img {
    width: 0.13rem;
    height: 0.13rem;
    margin-left: 0.12rem;
    margin-right: 0.08rem;
  }
  div {
    font-size: 0.12rem;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #999999;
  }
}
.find {
  ::v-deep .van-search {
    padding: 0.1rem 0.12rem;
    .van-search__content {
      padding-left: 0.12rem;
      border-radius: 0.14rem;
      .van-cell {
        padding: 0.05rem 0.08rem 0.05rem 0;
        font-size: 0.12rem;
        line-height: 0.19rem;
        .van-field__left-icon {
          margin-right: 0.04rem;
          .van-icon {
            font-size: 0.16rem;
            color: #999999;
          }
        }
        .van-field__control::placeholder {
          font-size: 0.12rem;
        }
      }
    }
    .van-search__action {
      padding: 0 0.08rem;
      font-size: 0.14rem;
      line-height: 0.34rem;
    }
  }
}
.fade-enter-active {
  transition: all 0.3s linear;
  transform: translateX(0);
}
.fade-leave-active {
  transition: all 0.3s linear;
  transform: translateX(200%);
  opacity: 0;
}
.fade-enter {
  transform: translateX(-100%);
  // opacity: 0;
}
.fade-leave {
  transform: translateX(0);
}
.fade-enter-to {
  // display: none;
  opacity: 0.8;
}
</style>
